import { Grid, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import React, { useEffect } from "react";
import { Link, Route, Switch, useRouteMatch } from "react-router-dom";
import Addma from "../img/Addma.png";
import Charactermatch from "../img/Charactermatch.png";
import ControllerRow from "../img/ControllerRow.png";
import ControllerRow2 from "../img/ControllerRow2.png";
import ControllerRow3 from "../img/ControllerRow3.png";
import ControllerRow4 from "../img/ControllerRow4.png";
import ControllerRow5 from "../img/ControllerRow5.png";
import Controllerrow6 from "../img/Controllerrow6.png";
import Hitenter from "../img/Hitenter.png";
import Keyboardshortcuts1 from "../img/Keyboardshortcuts1.png";
import Keyboardshortcuts2 from "../img/Keyboardshortcuts2.png";
import MAgrade from "../img/MAgrade.png";
import Multipleacceptableanswers from "../img/Multipleacceptableanswers.png";
import MultipleanswersRP from "../img/MultipleanswersRP.png";
import Multiplecopiesadded from "../img/Multiplecopiesadded.png";
import Savingonlinepaper from "../img/Savingonlinepaper.png";
import TipsCreatepage from "../img/TipsCreatepage.png";
import answerkey1 from "../img/answerkey1.png";

const useStyles = makeStyles((theme) => ({
  topicMain: {},
  root: {
    minHeight: "50vh",
    marginTop: "70px",
    paddingBottom: "50px",
    width: "100%",
    maxWidth: "800px",
    "& a": {
      color: "#4381b5",
    },
    "& h2": {
      marginBottom: "30px",
    },
    "& h4": {
      margin: "30px 0px",
    },
    "& img": {
      boxShadow: "0 3px 10px rgb(0 0 0 / 0.4)",
      borderRadius: "4px",

      // transition: "transform .2s",
      // "&:hover": {
      //   transform: "scale(1.3)",
      // },
    },
    "& ul": { marginLeft: "20px" },
    "& li": {
      marginLeft: "20px",
    },
  },
  detailsgrid: {
    height: "40px",
  },
  detailsgridline: {
    display: "inline-block",
    margin: "auto 30px",
  },
  imgSize: {
    maxWidth: "350px",
    width: "90%",
    display: "block",
    margin: "20px auto",
    marginBottom: "40px",
  },
  imgSize2: {
    maxWidth: "370px",
    width: "90%",
    margin: "20px auto",
    display: "block",
    marginTop: "20px",
  },
  imgSize3: {
    maxWidth: "300px",
    width: "80%",
    margin: "15px 20px 20px 20px",
    display: "block",
  },
  hyperlink: {
    textDecoration: "none",
    color: "#8277FF !important",
  },
  fontHeading: {
    marginBottom: "40px",
    fontSize: "28px",
    [theme.breakpoints.down("xs")]: {
      fontSize: "22px",
    },
  },
  highlighted: {
    backgroundColor: "#d8d2e7",
    width: "max-content",
    borderLeft: "5px solid #d8d2e7",
    borderRight: "5px solid #d8d2e7",
  },
}));

function WalkthroughVideo() {
  const classes = useStyles();
  return (
    <div className={classes.root} style={{ maxWidth: "900px" }}>
      <div>
        <Typography variant="h5" className={classes.fontHeading}>
          Walkthrough video: Creating an answer key
        </Typography>
      </div>
      <div display="block">
        <Typography className={classes.details} variant="body2">
          The following video will tell you everything you need to know about
          how to create an answer key, plus some useful tips and tricks:
        </Typography>

        <div
          class="wistia_responsive_padding"
          style={{
            padding: "56.25% 0 0 0",
            position: "relative",
            boxShadow: "0 3px 10px rgb(0 0 0 / 0.2)",
            borderRadius: "4px",
            marginBottom: "30px",
            marginTop: "30px",
          }}
        >
          <div
            class="wistia_responsive_wrapper"
            style={{
              height: "100%",
              left: "0",
              position: "absolute",
              top: "0",
              width: "100%",
            }}
          >
            <div
              class="wistia_embed wistia_async_2sukiwpt2k videoFoam=true"
              style={{ height: "100%", position: "relative", width: "100%" }}
            >
              <div
                class="wistia_swatch"
                style={{
                  height: "100%",
                  left: "0",
                  opacity: "0",
                  overflow: "hidden",
                  position: "absolute",
                  top: "0",
                  transition: "opacity 200ms",
                  width: "100%",
                }}
              >
                <img
                  src="https://fast.wistia.com/embed/medias/2sukiwpt2k/swatch"
                  style={{
                    filter: "blur(5px)",
                    height: "100%",
                    objectFit: "contain",
                    width: "100%",
                  }}
                  alt=""
                  aria-hidden="true"
                  onload="this.parentNode.style.opacity=1;"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

function TipsCreatingKey() {
  const classes = useStyles();
  return (
    <div className={classes.root} style={{ maxWidth: "900px" }}>
      <div>
        <Typography variant="h5" className={classes.fontHeading}>
          Tips and tricks - Creating an answer keys
        </Typography>
      </div>
      <div display="block">
        <Typography className={classes.details} variant="body2">
          <a href="#hitenter">Hit Enter to input an answer</a>
          <br />
          <br />
          <a href="#hittab">Hit tab to go to the next answer</a>
          <br />
          <br />
          <a href="#multiplecopies">
            Add multiple copies of a template with the controller row
          </a>
          <br />
          <br />
          <a href="#keyboardshortcuts">Use keyboard shortcuts</a>
          <br />
          <br />
          <a href="#settingsmemory">Settings memory</a>
          <br />
          <br />
          <a href="#watchmatching">
            Watch out for character matching in Math answers
          </a>
          <br />
          <br />
        </Typography>
        <Typography className={classes.highlighted} variant="h6" id="hitenter">
          Hit Enter to input an answer:{" "}
        </Typography>
        <Typography className={classes.details} variant="body2">
          Instead of clicking the + button to add a row, trying hitting Enter on
          your keyboard.
        </Typography>
        <img
          style={{ maxWidth: "800px" }}
          className={classes.imgSize}
          src={Hitenter}
          alt="Hit enter"
        />
        <Typography className={classes.details} variant="body2">
          Note that this also works for multiple choice answers.
        </Typography>

        <Typography className={classes.highlighted} variant="h6" id="hittab">
          Hit tab to go to the next answer:{" "}
        </Typography>

        <Typography className={classes.details} variant="body2">
          Hitting tab always takes you to the next answer field.
        </Typography>

        <Typography
          className={classes.highlighted}
          variant="h6"
          id="multiplecopies"
        >
          Add multiple templates with the controller row:
        </Typography>
        <Typography className={classes.details} variant="body2">
          If many of your answers have the same elements, pre-set them in the
          controller row and then add multiple copies into your answer key.
          <br />
          <br />
          For example, if you know your first 3 answers all have m/s for units,
          you can type that in:
        </Typography>
        <img
          style={{ maxWidth: "800px" }}
          className={classes.imgSize}
          src={TipsCreatepage}
          alt="Tips"
        />
        <Typography className={classes.details} variant="body2">
          and then add 3 copies into your answer key:
        </Typography>
        <img
          style={{ maxWidth: "800px" }}
          className={classes.imgSize}
          src={Multiplecopiesadded}
          alt="Multiple copies"
        />
        <Typography
          className={classes.highlighted}
          variant="h6"
          id="keyboardshortcuts"
        >
          Use keyboard shortcuts:
        </Typography>
        <Typography className={classes.details} variant="body2">
          To save time, use our{" "}
          <Link
            className={classes.hyperlink}
            to="/help-topics/create-answer-key-topics/keyboard-shortcuts"
          >
            Keyboard shortcuts
          </Link>{" "}
          when inputting Math and Numeric answers.
        </Typography>
        <Typography
          className={classes.highlighted}
          variant="h6"
          id="settingsmemory"
        >
          Memory:
        </Typography>
        <Typography className={classes.details} variant="body2">
          SwiftGrade has ‘memory’. This means if you turn Units on for a Numeric
          answer, the next time you come back to the Numeric answer type
          SwiftGrade will remember this setting.
        </Typography>
        <Typography
          className={classes.highlighted}
          variant="h6"
          id="watchmatching"
        >
          Watch out for character matching in Math answers:
        </Typography>
        <Typography className={classes.details} variant="body2">
          Unfortunately, for certain types of Math answers, SwiftGrade cannot
          find equivalence and thus those answers will be character matched.
          <br />
          <br />
          This means that only if the student writes their answer in the exact
          same format as your answer will they be marked correct.
          <br />
          <br />
          If an answer will be graded using character matching, this ‘warning’
          icon will appear next to your answer:
        </Typography>
        <img
          style={{ maxWidth: "800px" }}
          className={classes.imgSize}
          src={Charactermatch}
          alt="Char match"
        />
        <Typography className={classes.detailsgrid} variant="body2">
          If your answer was f(2) = 20, then only students who wrote exactly
          f(2) = 20 would be marked correct:
          <br />
          <br />
        </Typography>
        <Grid container>
          <Grid item xs={6} sm={3}>
            <Typography className={classes.detailsgrid} variant="body2">
              Student 1: <span style={{ color: "green" }}> f(2) = 20</span>
            </Typography>
            <Typography className={classes.detailsgrid} variant="body2">
              Student 2: <span style={{ color: "red" }}> 20 = f(2) </span>
            </Typography>
            <Typography className={classes.detailsgrid} variant="body2">
              Student 3:
              <span style={{ color: "red" }}> f(2) = (10+10)</span>
            </Typography>
          </Grid>
          <Grid item xs={6} sm={3}>
            <Typography className={classes.detailsgrid} variant="body2">
              Mark: 1/1
            </Typography>
            <Typography className={classes.detailsgrid} variant="body2">
              Mark: 0/1
            </Typography>
            <Typography className={classes.detailsgrid} variant="body2">
              Mark: 0/1
            </Typography>
          </Grid>
        </Grid>
      </div>
    </div>
  );
}
function UsingControllerRow() {
  const classes = useStyles();
  return (
    <div className={classes.root} style={{ maxWidth: "900px" }}>
      <div>
        <Typography variant="h5" className={classes.fontHeading}>
          Adding answers into the answer key
        </Typography>
      </div>
      <div display="block">
        <Typography className={classes.details} variant="body2">
          <a href="#whatiscontroller">What's the controller row?</a>
          <br />
          <br />
          <a href="#addanswers">How to add answers using the controller row?</a>
          <br />
          <br />
          <a href="#controllertips">Controller row tips</a>
          <br />
          <br />
        </Typography>
        <Typography
          className={classes.highlighted}
          variant="h6"
          id="whatiscontroller"
        >
          What's the controller row?
        </Typography>
        <Typography className={classes.details} variant="body2">
          The controller row is used to quickly add answers into the answer key.
          <br />
          <br />
          The controller row is always under your answer key, below the dashed
          line. It also has a grey color to distinguish it from regular rows in
          your answer key, as can be seen below:
          <br />
          <br />
          Controller row with no answers in the answer key:
        </Typography>
        <img
          style={{ maxWidth: "800px" }}
          className={classes.imgSize}
          src={ControllerRow}
          alt="Controller Row"
        />
        <Typography className={classes.details} variant="body2">
          Controller row with two answers in the answer key:
        </Typography>
        <img
          style={{ maxWidth: "800px" }}
          className={classes.imgSize}
          src={ControllerRow2}
          alt="Controller Row"
        />

        <Typography
          className={classes.highlighted}
          variant="h6"
          id="addanswers"
        >
          How to add answers using the controller row?
        </Typography>

        <Typography className={classes.details} variant="body2">
          You can add one or multiple copies of the controller row into the
          answer key.
          <br />
          <br />
          To add one copy of the controller row, either click + or hit enter on
          your keyboard while your cursor is in an answer field:
        </Typography>
        <img
          style={{ maxWidth: "800px" }}
          className={classes.imgSize}
          src={ControllerRow3}
          alt="Controller Row"
        />
        <Typography className={classes.details} variant="body2">
          To add multiple copies of the controller row, click ++:
        </Typography>
        <img
          style={{ maxWidth: "800px" }}
          className={classes.imgSize}
          src={ControllerRow4}
          alt="Controller Row"
        />

        <Typography
          className={classes.highlighted}
          variant="h6"
          id="controllertips"
        >
          Controller row tips:
        </Typography>
        <Typography className={classes.details} variant="body2">
          Tips with the controller row:
        </Typography>
        <ul>
          <li>
            <Typography className={classes.details} variant="body2">
              Type your answer and then click ‘Enter’ on the keyboard for rapid
              entry.
              <br />
              <br />
            </Typography>
          </li>
          <li>
            <Typography className={classes.details} variant="body2">
              If many of your answers have the same elements, pre-set them in
              the controller row and then add multiple copies into your answer
              key.
              <br />
              <br />
            </Typography>
          </li>
          <Typography className={classes.details} variant="body2">
            For example, if you know your first 3 answers all have m/s for
            units, you can type that in:
          </Typography>
          <img
            style={{ maxWidth: "800px" }}
            className={classes.imgSize}
            src={ControllerRow5}
            alt="Controller Row"
          />
          <Typography className={classes.details} variant="body2">
            and then add 3 copies of the controller row into your answer key:
          </Typography>
          <img
            style={{ maxWidth: "800px" }}
            className={classes.imgSize}
            src={Controllerrow6}
            alt="Controller Row"
          />
        </ul>
      </div>
    </div>
  );
}

function KeyboardShortcuts() {
  const classes = useStyles();
  return (
    <div className={classes.root} style={{ maxWidth: "900px" }}>
      <div>
        <Typography variant="h5" className={classes.fontHeading}>
          Keyboard Shortcuts
        </Typography>
      </div>
      <div display="block">
        <Typography className={classes.details} variant="body2">
          <a href="#intro">Introduction</a>
          <br />
          <br />
          <a href="#commonsymbols">Common symbols</a>
          <br />
          <br />
          <a href="#expressionentry">Expression entry and navigation:</a>
          <br />
          <br />
        </Typography>
        <Typography className={classes.highlighted} variant="h6" id="intro">
          Introduction
        </Typography>
        <Typography className={classes.details} variant="body2">
          Keyboard shortcuts help you save time when inputting Math and Numeric
          answers into the answer key.
        </Typography>

        <Typography
          className={classes.highlighted}
          variant="h6"
          id="commonsymbols"
        >
          Common Symbols:
        </Typography>

        <Typography className={classes.details} variant="body2">
          See common symbols in the table below:
        </Typography>
        <img
          style={{ maxWidth: "800px" }}
          className={classes.imgSize}
          src={Keyboardshortcuts1}
          alt="Shortcuts"
        />
        <Typography
          style={{ fontStyle: "italic" }}
          className={classes.details}
          variant="body2"
        >
          Rows with an asterix * means that the shortcut will only work for Math
          answers.
        </Typography>

        <Typography
          className={classes.highlighted}
          variant="h6"
          id="expressionentry"
        >
          Expression entry and navigation:
        </Typography>

        <Typography className={classes.details} variant="body2">
          See expression entry and navigation shortcuts in the table below:
        </Typography>

        <img
          style={{ maxWidth: "800px" }}
          className={classes.imgSize}
          src={Keyboardshortcuts2}
          alt="Shortcuts"
        />
        <Typography
          style={{ fontStyle: "italic" }}
          className={classes.details}
          variant="body2"
        >
          Rows with an asterix * means that the shortcut will only work for Math
          answers.
        </Typography>
      </div>
    </div>
  );
}

function AddingMultipleAnswers() {
  const classes = useStyles();
  return (
    <div className={classes.root} style={{ maxWidth: "900px" }}>
      <div>
        <Typography variant="h5" className={classes.fontHeading}>
          Adding multiple acceptable answers
        </Typography>
      </div>
      <div display="block">
        <Typography className={classes.details} variant="body2">
          <a href="#whataremultiple">What are multiple acceptable answers?</a>
          <br />
          <br />
          <a href="#howaremultiple">How are multiple answers graded?</a>
          <br />
          <br />
          <a href="#howareacceptable">
            How are multiple acceptable answers shown on the results page?
          </a>
          <br />
          <br />
        </Typography>
        <Typography
          className={classes.highlighted}
          variant="h6"
          id="whataremultiple"
        >
          What are multiple acceptable answers?
        </Typography>
        <Typography className={classes.details} variant="body2">
          For Math, Numeric, and Fill in the blank answer types, you can assign
          more than one correct answer per row, each with its own mark:
        </Typography>
        <img
          style={{ maxWidth: "800px" }}
          className={classes.imgSize}
          src={Addma}
          alt="Add MA"
        />
        <Typography className={classes.details} variant="body2">
          You can add up to 8 acceptable answers per row.{" "}
        </Typography>

        <Typography
          className={classes.highlighted}
          variant="h6"
          id="howaremultiple"
        >
          How are multiple acceptable answers graded?
        </Typography>

        <Typography className={classes.details} variant="body2">
          When grading, SwiftGrade will take the student’s answer, mark it
          against each acceptable answer, and then choose the one that gives the
          student the highest mark.
          <br />
          <br />
          For example, if your acceptable answers were this:
        </Typography>
        <img
          style={{ maxWidth: "800px" }}
          className={classes.imgSize}
          src={MAgrade}
          alt="MA Grade"
        />
        <Typography className={classes.details} variant="body2">
          And the student wrote: 200 m3
          <br />
          <br />
          SwiftGrade would match it to the 2nd answer because that one gives a
          higher mark (0.75/1 marks) compared to the first answer (0.25/1
          marks).
        </Typography>

        <Typography
          className={classes.highlighted}
          variant="h6"
          id="howareacceptable"
        >
          How are multiple acceptable answers shown on the results page?
        </Typography>

        <Typography className={classes.details} variant="body2">
          On the results page, if there are multiple acceptable answers, there
          is a drop down arrow in the answer key column.
        </Typography>

        <img
          style={{ maxWidth: "800px" }}
          className={classes.imgSize}
          src={MultipleanswersRP}
          alt="Mutiple ans"
        />
        <Typography className={classes.details} variant="body2">
          When clicked, the expanded drop down highlights the answer that the
          student matched with.
        </Typography>
        <img
          style={{ maxWidth: "800px" }}
          className={classes.imgSize}
          src={Multipleacceptableanswers}
          alt="Mutiple ans"
        />
      </div>
    </div>
  );
}

function SavingOnlinePaper() {
  const classes = useStyles();
  return (
    <div className={classes.root} style={{ maxWidth: "900px" }}>
      <div>
        <Typography variant="h6" className={classes.fontHeading}>
          Online vs. paper assessments
        </Typography>
      </div>
      <div display="block">
        <Typography className={classes.details} variant="body2">
          Once you are done inputting your answers and click ‘Create’, you will
          be asked if this assessment will be administered online or on paper:
        </Typography>
        <img
          style={{ maxWidth: "800px" }}
          className={classes.imgSize}
          src={Savingonlinepaper}
          alt="Saving"
        />
        <Typography className={classes.details} variant="body2">
          If on paper, you will need to print paper answer sheets and give them
          to students.
          <br />
          <br />
          If online, you will need to release online answer sheets to students.
          Note that students must be enrolled in your class to access these
          online answer sheets.
        </Typography>
      </div>
    </div>
  );
}

function WhatIsAnAnswerKey() {
  const classes = useStyles();
  return (
    <div className={classes.root} style={{ maxWidth: "900px" }}>
      <div>
        <Typography variant="h6" className={classes.fontHeading}>
          What is an answer key?
        </Typography>
      </div>
      <div display="block">
        <Typography className={classes.details} variant="body2">
          An answer key is a form that contains the correct answers to your
          assessment. Here is an example of an answer key with 5 answers:
        </Typography>
        <img
          style={{ maxWidth: "800px" }}
          className={classes.imgSize}
          src={answerkey1}
          alt="Answer Key"
        />
        <Typography className={classes.details} variant="body2">
          Student answers are compared to your answer key to generate a score.
        </Typography>
      </div>
    </div>
  );
}

function CreateAnswerKeyTopics() {
  const { path } = useRouteMatch();
  useEffect(() => {
    const script1 = document.createElement("script");
    const script2 = document.createElement("script");

    script1.src = "https://fast.wistia.com/embed/medias/2sukiwpt2k.jsonp";
    script1.async = true;

    script2.src = "https://fast.wistia.com/assets/external/E-v1.js";
    script2.async = true;

    document.body.appendChild(script1);
    document.body.appendChild(script2);
  }, []);

  return (
    <>
      <Switch>
        <Route path={`${path}/walkthrough-answer-key`}>
          <WalkthroughVideo />
        </Route>
        <Route path={`${path}/what-is-an-answer-key`}>
          <WhatIsAnAnswerKey />
        </Route>
        <Route path={`${path}/creating-answer-key-tips`}>
          <TipsCreatingKey />
        </Route>
        <Route path={`${path}/using-controller-row`}>
          <UsingControllerRow />
        </Route>
        <Route path={`${path}/keyboard-shortcuts`}>
          <KeyboardShortcuts />
        </Route>
        <Route path={`${path}/adding-multiple-acceptable`}>
          <AddingMultipleAnswers />
        </Route>
        <Route path={`${path}/save-as-online`}>
          <SavingOnlinePaper />
        </Route>
      </Switch>
    </>
  );
}

export default CreateAnswerKeyTopics;
